import homeContent from '../../../content/pages/home.json';

const productCategories = homeContent.productCategories;

export default productCategories;
